module.exports = __webpack_public_path__ + "assets/7595988ab40e913a56a92819cdcf875e.jpg";